module.exports = __webpack_public_path__ + "static/media/product_image.407794e7.png";